module.exports = __webpack_public_path__ + "static/autopal-264b6a0d2bdaba4f3f5d0c42e7ceafed.png";